import React from 'react';
import { FaSignOutAlt, FaTimes, FaIdBadge } from 'react-icons/fa';

const SUPPORTED_FILTER_STATUSES = new Set(['Pending', 'Approved', 'Rejected', 'Disabled']);

const UserProfileSidebar = ({ user, roles, isOpen, onClose, onLogout, onNavigate }) => {
    if (!isOpen) return null;

    const displayName = user?.firstName || user?.given_name || localStorage.getItem('firstName') || user?.username || localStorage.getItem('username') || 'User';
    const username = user?.username || localStorage.getItem('username') || 'User';

    const email = user?.email || user?.unique_name || 'No email provided';
    const effectiveRoles = Array.isArray(roles) ? roles : [];
    const hasNavigableEmail = email && email !== 'No email provided';

    const handleRolesClick = () => {
        if (onNavigate) {
            const navParams = {};
            if (hasNavigableEmail) {
                navParams.email = email;
            }

            const normalizedStatus = typeof user?.approvalStatus === 'string' ? user.approvalStatus.trim() : '';
            if (SUPPORTED_FILTER_STATUSES.has(normalizedStatus)) {
                navParams.filterStatus = normalizedStatus;
            }

            onNavigate('users', Object.keys(navParams).length > 0 ? navParams : undefined);
            onClose();
        }
    };

    const handleRolesKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleRolesClick();
        }
    };

    return (
        <>
            {/* Backdrop with fade-in effect */}
            <div className={`profile-sidebar-backdrop ${isOpen ? 'active' : ''}`} onClick={onClose}></div>

            <div className={`profile-sidebar ${isOpen ? 'open' : ''}`}>
                <div className="profile-sidebar-header">
                    <div className="header-title">
                        <h3>My Account</h3>
                    </div>
                    {/* Improved Close Button */}
                    <button className="close-btn-round" onClick={onClose} aria-label="Close Sidebar">
                        <FaTimes />
                    </button>
                </div>

                <div className="profile-sidebar-content">
                    <div className="profile-hero-section">
                        <div className="profile-avatar-large">
                            {username.charAt(0).toUpperCase()}
                        </div>
                        <h2 className="profile-username">{displayName}</h2>

                        <p className="profile-email">{email}</p>
                    </div>

                    <div className="profile-details">
                        {/* Roles Section - Clickable */}
                        <div
                            className="detail-item clickable-detail"
                            onClick={handleRolesClick}
                            onKeyDown={handleRolesKeyDown}
                            title="Manage Your Access"
                            role="button"
                            tabIndex={0}
                            aria-label="Manage your assigned roles"
                        >
                            <div className="detail-icon-wrapper">
                                <FaIdBadge className="detail-icon" />
                            </div>
                            <div className="detail-text">
                                <div className="detail-header">
                                    <span className="label">Assigned Roles</span>
                                </div>
                                <div className="roles-container">
                                    {effectiveRoles.length > 0 ? (
                                        effectiveRoles.map((role, index) => (
                                            <span key={index} className="role-badge">
                                                {role}
                                            </span>
                                        ))
                                    ) : (
                                        <span className="role-badge guest">Member</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="profile-sidebar-footer">
                    <button className="logout-btn-premium" onClick={onLogout}>
                        <FaSignOutAlt />
                        <span>Log Out</span>
                    </button>
                </div>
            </div>
        </>
    );
};

export default UserProfileSidebar;